import { createContext } from 'react'
import type { TenantEntry } from '../services/schemas'

export interface TenantContextValue {
  schemas: TenantEntry[]
  selectedTenant: TenantEntry | null
  setSelectedTenant: (tenant: TenantEntry) => void
  isLoading: boolean
  error: string | null
}

export const TenantContext = createContext<TenantContextValue | null>(null)
